const ProductFeatures = () => {
const features = [
  {
    icon: "https://luvit.com.bd/wp-content/uploads/2026/01/Group.svg",
    title: "Natural Ingredients",
    description:
      "Praesent in nunc vel urna consequat mattis eget vel libero. Phasellus entesque",
  },
  {
    icon: "https://luvit.com.bd/wp-content/uploads/2026/01/Group-1.svg",
    title: "Sustainably Sourced",
    description:
      "Ethically sourced ingredients that respect nature and communities.",
  },
  {
    icon: "https://luvit.com.bd/wp-content/uploads/2026/01/Group-2.svg",
    title: "Heritage Formulas",
    description:
      "Traditional botanical wisdom refined by modern clean science.",
  },
  {
    icon: "https://luvit.com.bd/wp-content/uploads/2026/01/Group-3.svg",
    title: "Paraben Free",
    description:
      "Mattis eget vel libero praesent in nunc vel urna consequat phasellus entesque",
  },
];


  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 ">
          {features.map((feature, index) => (
            <div
              key={index}
              className="text-center group transition-all duration-300 hover:-translate-y-2 "
            >
              <div className="flex justify-center mb-6">
                <img
                  src={feature.icon}
                  alt={feature.title}
                  className="w-14 h-14 object-contain opacity-90 group-hover:opacity-100 transition"
                />
              </div>

              <h3 className="text-lg font-semibold mb-3">
                {feature.title}
              </h3>

              <p className="text-sm leading-relaxed max-w-xs mx-auto text-gray-800">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductFeatures;
